import axios from 'axios';
import { Scenario } from 'views/bluviu-nutrition/features/scenarios-v2/types/scenario.type';

export const getR2Scenario = async (scenarioId: string, globalSiteId: string): Promise<Scenario> => {
  const res = await axios.get<Scenario>(`/ewosapi/v1/scenarios/gt2-multi/${scenarioId}?globalSiteId=${globalSiteId}`);

  return res.data;
};
